import { useEmoji } from '../context/EmojiContext';
import {
  DashboardIcon,
  EmailIcon,
  HealthIcon,
  HelpIcon,
  LogsIcon,
  PortsIcon,
  ScheduleIcon,
  SendIcon,
  VesselsIcon,
} from './Icons';

const NAV_ITEMS = [
  { id: 'home', label: 'Dashboard', emoji: '📊', icon: 'grid' },
  { id: 'emails', label: 'Emails', emoji: '📧', icon: 'mail' },
  // { id: 'ports', label: 'Ports', emoji: '⚓', icon: 'anchor' },
  { id: 'vessels', label: 'Vessels', emoji: '🚢', icon: 'ship' },
  { id: 'logs', label: 'Email Logs', emoji: '📋', icon: 'terminal' },
  { id: 'scheduled-jobs', label: 'Scheduled Emails', emoji: '🗓️', icon: 'calendar' },
  { id: 'send-email', label: 'Send Email', emoji: '✉️', icon: 'send' },
  { id: 'help', label: 'Help', emoji: '❓', icon: 'help' },
  { id: 'health', label: 'System Health', emoji: '💚', icon: 'health' },
];

function NavIcon({ name }) {
  const icons = {
    grid: <DashboardIcon />,
    mail: <EmailIcon />,
    anchor: <PortsIcon />,
    ship: <VesselsIcon />,
    send: <SendIcon />,
    calendar: <ScheduleIcon />,
    terminal: <LogsIcon />,
    help: <HelpIcon />,
    health: <HealthIcon />,
  };

  return <span className="nav-icon">{icons[name]}</span>;
}

function Sidebar({ activeItem, onNavigate, isOpen, onClose }) {
  const { isEmojified } = useEmoji();

  return (
    <>
      <div
        className={`sidebar-backdrop ${isOpen ? 'sidebar-backdrop--visible' : ''}`}
        onClick={onClose}
        aria-hidden="true"
      />
      <aside className={`sidebar ${isOpen ? 'sidebar--open' : ''}`}>
        <div className="sidebar__brand">
          <div className="sidebar__logo">
            <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="EKDANTAYA" />
          </div>
          <h1>EKDANTAYA</h1>
          <p>Email Marketing System</p>
        </div>

        <nav className="sidebar__nav" aria-label="Main navigation">
          {NAV_ITEMS.map((item) => (
            <button
              key={item.id}
              type="button"
              className={`sidebar__nav-item ${activeItem === item.id ? 'sidebar__nav-item--active' : ''}`}
              onClick={() => onNavigate(item.id)}
            >
              {isEmojified ? (
                <span className="nav-icon" aria-hidden="true">
                  {item.emoji}
                </span>
              ) : (
                <NavIcon name={item.icon} />
              )}
              <span>{item.label}</span>
            </button>
          ))}
        </nav>
      </aside>
    </>
  );
}

export default Sidebar;
